import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { EncroachmentStatusDto } from '@cradua/data';
import Swal from 'sweetalert2';


@Component({
  selector: 'cradua-encroachmentstatus',
  templateUrl: './encroachmentstatus.component.html',
  styleUrls: ['./encroachmentstatus.component.scss']
})
export class EncroachmentStatusComponent implements OnChanges {


  encroachmentstatusForm: FormGroup;
  encroachmentstatusFormArray: FormGroup;
  control = new FormControl();
  @Input() encroachmentstatuss: EncroachmentStatusDto[];
  @Input() routeAnimationsElements: any;
  @Output() encroachmentstatus = new EventEmitter<EncroachmentStatusDto[]>()
  @Output() deleteEncroachmentStatusEvent = new EventEmitter<any>()

    selectedEncroachmentStatus: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createEncroachmentStatusForm();
    }

    createEncroachmentStatusForm() {
      this.encroachmentstatusForm = this.fb.group({
        EncroachmentStatusName: ['', Validators.required],
      
        id: null
        });
        this.encroachmentstatusFormArray = this.fb.group({ EncroachmentStatuss: this.fb.array([])
          });
        this.setEncroachmentStatus();
    }

  // method to display encroachmentstatuss
  setEncroachmentStatus() {
    const control  = this.encroachmentstatusFormArray.controls.EncroachmentStatuss as FormArray;
    this.encroachmentstatuss.forEach( e => {
      control.push(
        this.fb.group({
          EncroachmentStatusName: e.EncroachmentStatusName,
         
          id: e.id
        })
      );
    });
  }


  // method to add EncroachmentStatus
  addEncroachmentStatus(value: EncroachmentStatusDto) {
    const control  = this.encroachmentstatusFormArray.controls.EncroachmentStatuss as FormArray;
    control.insert(0,
          this.fb.group({
            EncroachmentStatusName: value.EncroachmentStatusName,
           
            id: null
          })
       );
  }

  selectEncroachmentStatus(value) {}

  // method to delete encroachmentstatus from arrary list
  deleteEncroachmentStatus(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.encroachmentstatusFormArray.controls.EncroachmentStatuss as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.encroachmentstatuss.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.encroachmentstatuss[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: EncroachmentStatusDto) {
    if(this.encroachmentstatusForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.encroachmentstatusFormArray.get('EncroachmentStatuss')['controls'][this.selectedIndex].patchValue({EncroachmentStatusName: formValue.EncroachmentStatusName});
    } else {
      this.addEncroachmentStatus(formValue);
    }
    this.selectedIndex = null;
    this.encroachmentstatusForm.reset()
  }

  onEdit(index, value: EncroachmentStatusDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.encroachmentstatusForm.patchValue({EncroachmentStatusName: value.EncroachmentStatusName});
   
  }

  onClearForm() {
    this.selectedIndex = null;
    this.encroachmentstatusForm.reset();
  }

  onSubmit(formValue: EncroachmentStatusDto[]) {
  this.encroachmentstatus.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteEncroachmentStatusEvent.emit(this.filteredDelete);
  }
  }

}
